<template>
  <div class="my-2 inline-flex gap-4">
    <label
      v-for="opt in options"
      :key="opt.value"
      class="pe-radio-button"
      :class="{ 
        '--radio-selected': selected === opt.value,
        'cursor-not-allowed': disabled
      }"
      tabindex="0"
    >
      <input type="radio" v-model="selected" :name="radioName" :value="opt.value" :disabled="disabled" class="hidden" />
      <span>{{ opt.label }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { generateUUID } from '@/common/util'

const props = defineProps<{
  modelValue: any
  options: {
    label: string
    value: any
  }[]
  beforeChange?: any
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const radioName = ref('')

const selected = computed({
  get: () => props.modelValue,
  set: (value) => onChange(value)
})

const onChange = (to: string | number | boolean) => {
  if (typeof props.beforeChange === 'function') {
    Promise.resolve(props.beforeChange(to, selected.value))
      .then((result) => result && emit('update:modelValue', to))
      .catch(() => {})
  } else {
    emit('update:modelValue', to)
  }
}

onMounted(() => {
  radioName.value = `p-rg-${generateUUID()}`
})

defineExpose({
  selected
})
</script>

<style lang="scss">
.pe-radio-button {
  @apply relative cursor-pointer rounded-3xl bg-white px-6 py-2 text-center text-sm font-medium leading-[24px] drop-shadow-[0_0_2px_rgba(0,0,0,.1)] transition-colors dark:bg-neutral-700;

  &.--radio-selected {
    @apply bg-black text-white dark:bg-neutral-900 dark:text-neutral-200;
  }

}

.--blue {
  .pe-radio-button {

    @apply bg-[#858288] text-white;

    &.--radio-selected {
      @apply bg-[#4F46E5];
    }
  }
}

.--blue {
  .pe-radio-button {
    @apply bg-[#858288];

    &.--radio-selected {
      @apply bg-[#4F46E5];
    }
  }
}
</style>
